import React, { useState, useEffect } from 'react';

import ICropper from '../../interfaces/ICropper';

import { constructDevSrc, constructCropperImage } from '../../utils/helpers';

interface Props {
	imageObj: ICropper | undefined;
	className?: string;
}

interface IListItemData {
	width: number;
	height: number;
	coordinates: null | { x1: string; y1: string; x2: string; y2: string };
}

const cropAliasis = [
	'desktopLg',
	'desktopLgRetina',
	'desktop',
	'desktopRetina',
	'desktopSm',
	'desktopSmRetina',
	'tablet',
	'tabletRetina',
	'mobile',
	'mobileRetina',
];

const Picture: React.FC<Props> = ({ imageObj, className }) => {
	const [imageParameters, setImageParameters] = useState<{
		[key: string]: IListItemData;
	}>();

	useEffect(() => {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		const tempObj: { [key: string]: IListItemData } = {};
		imageObj?.crops.forEach((crop) => {
			if (cropAliasis.includes(crop.alias)) {
				tempObj[crop.alias] = {
					width: crop.width,
					height: crop.height,
					coordinates: crop.coordinates,
				};
			}
		});
		setImageParameters(tempObj);
	}, [imageObj]);

	const { src, focalPoint } = imageObj || {};

	return (
		<picture className={className}>
			{imageParameters?.desktopLg && src && focalPoint && (
				<source
					media="(min-width: 1920px)"
					srcSet={`${constructDevSrc(
						constructCropperImage(
							src,
							focalPoint,
							imageParameters.desktopLg.coordinates,
							imageParameters.desktopLg.width,
							imageParameters.desktopLg.height
						)
					)} 1x${
						imageParameters?.desktopLgRetina
							? `, ${constructDevSrc(
								constructCropperImage(
									src,
									focalPoint,
									imageParameters.desktopLgRetina.coordinates,
									imageParameters.desktopLgRetina.width,
									imageParameters.desktopLgRetina.height
								)
							)} 2x`
							: ''
					} `}
				/>
			)}
			{imageParameters?.desktop && src && focalPoint && (
				<source
					media="(min-width: 1561px)"
					srcSet={`${constructDevSrc(
						constructCropperImage(
							src,
							focalPoint,
							imageParameters.desktop.coordinates,
							imageParameters.desktop.width,
							imageParameters.desktop.height
						)
					)} 1x${
						imageParameters?.desktopRetina
							? `, ${constructDevSrc(
								constructCropperImage(
									src,
									focalPoint,
									imageParameters.desktopRetina.coordinates,
									imageParameters.desktopRetina.width,
									imageParameters.desktopRetina.height
								)
							)} 2x`
							: ''
					} `}
				/>
			)}
			{imageParameters?.desktopSm && src && focalPoint && (
				<source
					media="(min-width: 1201px)"
					srcSet={`${constructDevSrc(
						constructCropperImage(
							src,
							focalPoint,
							imageParameters.desktopSm.coordinates,
							imageParameters.desktopSm.width,
							imageParameters.desktopSm.height
						)
					)} 1x${
						imageParameters?.desktopSmRetina
							? `, ${constructDevSrc(
								constructCropperImage(
									src,
									focalPoint,
									imageParameters.desktopSmRetina.coordinates,
									imageParameters.desktopSmRetina.width,
									imageParameters.desktopSmRetina.height
								)
							)} 2x`
							: ''
					}`}
				/>
			)}
			{imageParameters?.tablet && src && focalPoint && (
				<source
					media="(min-width: 769px)"
					srcSet={`${constructDevSrc(
						constructCropperImage(
							src,
							focalPoint,
							imageParameters.tablet.coordinates,
							imageParameters.tablet.width,
							imageParameters.tablet.height
						)
					)} 1x${
						imageParameters?.tabletRetina
							? `, ${constructDevSrc(
								constructCropperImage(
									src,
									focalPoint,
									imageParameters.tabletRetina.coordinates,
									imageParameters.tabletRetina.width,
									imageParameters.tabletRetina.height
								)
							)} 2x`
							: ''
					}`}
				/>
			)}
			{imageParameters?.mobile && src && focalPoint && (
				<source
					media="(min-width: 319px)"
					srcSet={`${constructDevSrc(
						constructCropperImage(
							src,
							focalPoint,
							imageParameters.mobile.coordinates,
							imageParameters.mobile.width,
							imageParameters.mobile.height
						)
					)} 1x${
						imageParameters?.mobileRetina
							? `, ${constructDevSrc(
								constructCropperImage(
									src,
									focalPoint,
									imageParameters.mobileRetina.coordinates,
									imageParameters.mobileRetina.width,
									imageParameters.mobileRetina.height
								)
							)} 2x`
							: ''
					}`}
				/>
			)}
			{imageParameters?.desktop && src && focalPoint && (
				<img
					src={constructDevSrc(
						constructCropperImage(
							src,
							focalPoint,
							imageParameters.desktop.coordinates,
							imageParameters.desktop.width,
							imageParameters.desktop.height
						)
					)}
					srcSet={
						imageParameters?.desktopRetina &&
						constructDevSrc(
							constructCropperImage(
								src,
								focalPoint,
								imageParameters.desktopRetina.coordinates,
								imageParameters.desktopRetina.width,
								imageParameters.desktopRetina.height
							)
						)
					}
					alt=""
				/>
			)}
		</picture>
	);
};

export default Picture;
